import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

interface OrgNode {
  id: number;
  name: string;
  parentId?: number;
}

interface OrgChartComponentProps {
  data: OrgNode[] | null;
  onNodeClick: (node: any) => void;
}

const OrgChartComponent: React.FC<OrgChartComponentProps> = ({ data, onNodeClick }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const chartInstance = useRef<any>(null);

  useEffect(() => {
    if (!data) return;

    // Set d3 on the window object first
    (window as any).d3 = d3;

    const loadChart = async () => {
      const TreeChart = (await import('d3-org-chart')).default;

      if (!chartInstance.current) {
        chartInstance.current = new TreeChart();
      }

      chartInstance.current
        .container(chartRef.current)
        .data(data)
        .svgWidth(800)
        .initialZoom(0.6)
        .onNodeClick(onNodeClick)
        .render();
    };

    loadChart();
  }, [data]);

  return <div ref={chartRef} />;
};

export default OrgChartComponent;
